
/**
 * File: qpSummary.js
 * Project: educore
 * Created Date: 2018-12-13
 * Author: Raziya S
 * Screen : 
 */
class StudentAnswerController {
    // @ngInject
    constructor($state, $rootScope, $scope, $mdMedia, $filter, $mdDialog, localStorageService, authService, activityCons, $stateParams, SchoolLogo, CONSTANTS, $sce) {

        let authoring = localStorageService.get("authoringData")
        let qpId = $state.params.qpId
        let studentId = localStorageService.get('user_id')
        let schoolId = authoring.school_id
        $scope.continue = false
        $scope.no_fee_status = false
        var self = this
        $scope.isLoading = true
        $scope.comment = undefined
        $scope.fee_status_label = true
        function getSchoolTokens(schoolId) {
            var dummySchool = [{
                "_id" : "2ebFyzgjEwmdvep5L",
                "school_name" : "The Oxford School,Trivandrum",
                "site_url" : "http://35.200.206.239:3600",
                "file_server" : "http://35.200.206.239:4000",
                // "school_data_url" : "https://portal.oxford.edu.in/index.php/portal_data_contract",
                // "school_data_token" : "d8ba88f080664a1420d2d080b658fc04"
                "school_data_url": "https://docmeschool.oxford.edu.in/api/app",
                "school_data_token": "53d553cca766bb843eeb6464608ac93e"
            }, 
            {
                "_id" : "Mvb8uY53ijBX9DNJS",
                "school_name" : "The Oxford School,Kollam",
                "site_url" : "http://35.200.206.239:3600",
                "file_server" : "http://35.200.206.239:4000",
                // "school_data_url" : "https://portal.oxfordkollam.edu.in/index.php/portal_data_contract",
                // "school_data_token" : "795dce7a5fa85ef8d4945441549b6578"
                "school_data_url": "https://docmeschool.oxford.edu.in/api/app",
                "school_data_token": "25c921722bec9527d59eb0e34713347c"
            }, 
            {
                "_id" : "f5BCz8T7LqzpFsSP3",
                "school_name" : "The Oxford School,Calicut",
                "site_url" : "http://35.200.206.239:3600",
                "file_server" : "http://35.200.206.239:4000",
                // "school_data_url" : "http://portal.oxfordcalicut.com/index.php/Portal_data_contract",
                // "school_data_token" : "cded12b4cd909d4e00610ff0699ca069"
                "school_data_url": "https://docmeschool.oxford.edu.in/api/app",
                "school_data_token": "aa8d7f8e0352b2712b9e80cf25bb60d4"
            }, 
            {
                "_id" : "CPpbKPQTcuG97i3kv",
                "school_name" : "The New Indian Model School,Dubai",
                "site_url" : "http://104.199.53.109:3700",
                "file_server" : "http://104.199.53.109:4000",
                // "school_data_url" : "https://portal.nimsdxb.com/index.php/portal_data_contract",
                // "school_data_token" : "e370c37780b957637493e9727c9b304d",
                // "school_data_url" : "http://qnap.ddns.cyberoam.com:3000/rims-tools/api/App",
                // "school_data_token" : "ed0a5a7f2b76668e8a6dd3388868c068"
                "school_data_url" : "https://bm-harvest.globtech.in/api/App",
                "school_data_token" : "7a9d733269d23bc35b04b56dc855d330"
            }, 
            {
                "_id" : "m2LMtqaESFZf6xDE8",
                "school_name" : "The Central School,Dubai",
                "site_url" : "http://104.199.53.109:3700",
                "file_server" : "http://104.199.53.109:4000",
                // "school_data_url" : "https://portal.centraldxb.com/index.php/portal_data_contract",
                // "school_data_token" : "f2f78f635a660af6257dab8da79c650f"
                "school_data_url" : "https://bm-harvest.globtech.in/api/App",
                "school_data_token" : "47e2b919b8551d762e1dd1f5769b66ba"
            }, 
            {
                "_id" : "2FwuqhgeoKt6SQiCG",
                "school_name" : "The New Indian Model School,Al-Ain",
                "site_url" : "http://104.199.53.109:3700",
                "file_server" : "http://104.199.53.109:4000",
                // "school_data_url" : "https://portal.nimsalain.com/index.php/portal_data_contract",
                // "school_data_token" : "874d4634f7c741f397045aeb7fd133c6"
                "school_data_url" : "https://bm-harvest.globtech.in/api/App",
                "school_data_token" : "0ae409a7d98dde57b35a4643d2354906"
            }, 
            {
                "_id" : "ps4vyLJhQvPZjfxaH",
                "school_name" : "The New Indian Model School,Sharjah",
                "site_url" : "http://104.199.53.109:3700",
                "file_server" : "http://104.199.53.109:4000",
                // "school_data_url" : "https://portal.nimsshj.com/index.php/portal_data_contract",
                // "school_data_token" : "8838d896e6aecc58323ef9b26c374ebe"
                "school_data_url" : "https://bm-harvest.globtech.in/api/App",
                "school_data_token": "99d351fe9165be1c0cf35fa0a0885c17"
            }]
            let ex = _.find(dummySchool, function (one) {
                return one._id == schoolId
            })
            return ex
        }
        function feesCheckOneStudent(){
            let school_id = localStorageService.get("school_id")
            let tokens = getSchoolTokens(school_id)
            let admn_no = localStorageService.get('admission_no')
            
            
            if(!admn_no){
                admn_no = localStorageService.get('st_admission_number')
            }
            console.log(admn_no)
            authService.callAPI("/v0/parent/portal/fee/", "POST", {
                school_data_token: tokens.school_data_token,
                school_data_url: tokens.school_data_url,
                admn_no: admn_no
            }, function (response) {
                try {
                    if (response.result.status.code == 200) {
                        if (response.result.data && response.result.data.details) {
                            self.feesDocument = response.result.data.details
                            var exmpList = (response.result.data.exemption_list)?response.result.data.exemption_list:[]; 
                            _.each(self.feesDocument, function (det, index) {
                                if(det.fee_last_date){
                                    let someDate = new Date(det.fee_last_date);
                                    let numberOfDaysToAdd = 20;
                                    someDate.setDate(someDate.getDate() + numberOfDaysToAdd);
                                    det.fee_last_date = someDate
                                }
                                // det.fee_last_date = new Date(det.fee_last_date)
                                let today = new Date()
                                det.fee_last_date.setHours(0, 0, 0, 0);
                                today.setHours(0, 0, 0, 0);
                                if (det.fee_last_date <= today) {
                                    if (det.fee_status === "Pending" && det.blocking_status === "Y") {
                                        var isExepted = exmpList.includes(admn_no);
                                        if(isExepted){
                                            $scope.fee_status_label = true
                                        } else {
                                            $scope.fee_status_label = false
                                        }
                                    } else {
                                        $scope.fee_status_label = true
                                    }
                                }
                            })
                            init()
                        } else {
                            $scope.fee_status_label = true
                            init()
                        }
                    } else {
                        $scope.fee_status_label = true
                    }
                } catch (ex) {
                    console.log(ex);
                    $scope.fee_status_label = true
                }
            })
        }
        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
            if (authoring) {
                feesCheckOneStudent()
                $rootScope.authMenu = true;
                $rootScope.title = authoring.class + "" + authoring.batch + "/" + authoring.curriculum + "/" + authoring.session + "/" + authoring.subject
            } else {
                $state.go("authdashboard")
            }
        }
        function init() {
            authService.callAPI(activityCons.API_GET_STUDENT_ANSWER_DETAILS + qpId + '/' + studentId, "GET", {}, function (response) {
                if (response.result && response.result.data && response.result.data.details) {
                    try {
                        let result = response.result.data.details;
                        if (result && result.comment) {
                            $scope.comment = result.comment
                        }
                        let useFullScreen = ($mdMedia('sm') || $mdMedia('xs'));
                        $scope.my_score = 0
                        $scope.totalmark = 0
                        $scope.quesCount = 0
                        let myScore = 0
                        $scope.isTeacherEvaluation = false
                        _.each(result.consolidatedData, function (sec) {
                            delete sec.questions
                            _.each(sec.answers, function (ans) {
                                if (ans.type === "SA" || ans.type === "LA" || ans.type == "ASLLISTEN" || ans.type == "ASLSPEAK" || ans.type == "DRAW") {
                                    $scope.quesCount++;
                                }
                                $scope.totalmark = ans.total_mark
                                if (!isNaN(ans.my_score)) {
                                    myScore = parseFloat(myScore) + parseFloat(ans.my_score)
                                    myScore = myScore.toFixed(2)
                                    $scope.my_score = myScore
                                }
                            })
                        })
                        $scope.qpDetails = {
                            question_paper_title: result.question_paper_title,
                            subject: authoring.subject,
                            class: authoring.class,
                            time: result.time,
                            due_date: result.due_date
                        }
                        $scope.questions = result.consolidatedData;
                        $scope.isLoading = false
                        setTimeout(() => {
                            $scope.loadLatex()
                        }, 100);
                        setChoice();
                    } catch (ex) {
                        console.log(ex);
                    }
                } else {
                    //toastr.error('Network Error. Please try later');
                }
                _.defer(function () {
                    $scope.$apply();
                });
            })
            //To get school details
            authService.callAPI(activityCons.API_GET_SCHOOL_DETAILS + schoolId, "POST", {}, (response) => {
                if (response.result && response.result.status && response.result.data.details) {
                    let result = response.result.data.details
                    console.log(result)
                    $scope.qpHeader = {
                        'schoolName': result.school_name,
                        'schoolLogo': SchoolLogo.checkLogo(CONSTANTS.FILE_UPLOAD_URL + result.logo),
                        'subject': authoring.subject,
                        'class': authoring.class
                    }
                    _.defer(function () {
                        $scope.$apply();
                    });
                } else {
                    //error
                }
            })
        }

        function removeSpecialCharacter(value) {
            if (value) {
                value = value.replace(/\\quad/g, "")
                value = value.replace(/\\/g, "")
            }
            return value
        }
        /* Set answered choice is wrong or correct*/
        function setChoice() {
            _.each($scope.questions, function (section) {
                _.each(section.answers, function (data, key) {
                    $scope.total_mark += parseFloat(data.mark)
                    let score = parseFloat(data.my_score)
                    $scope.score += score;
                    if (data.type == 'MCQ' || data.type == "IBT_MCQ") {
                        _.each(data.choice, function (choice) {
                            if ($scope.checkingChoiceExists(choice.desc, data)) {
                                if (!choice.correct) {
                                    choice.wrong = true
                                }
                            }
                        })
                    } else if (data.type == 'TF') {
                        _.each(data.choice, function (choice) {
                            if (data.my_answer != undefined && choice.tag === data.my_answer[0]) {
                                if (!choice.correct) {
                                    choice.wrong = true
                                } else {
                                    choice.correct = true
                                }
                            }
                        })
                    } else if (data.type == 'FIB' || data.type == "IBT_FIB") {
                        let key = 0
                        let whole_answer_correct = false
                        if (Number(data.my_score) > 0) {
                            whole_answer_correct = true
                        }
                        _.each(data.answer, function (choice) {
                            let correctAnswer = removeSpecialCharacter(choice.desc)
                            if (data.my_answer != undefined && data.my_answer[key] != undefined) {
                                let studentAnswer = removeSpecialCharacter(data.my_answer[key])
                                if (correctAnswer.toLowerCase().trim() !== studentAnswer.toLowerCase().trim()) {
                                    choice.wrong = true
                                } else {
                                    choice.correct = true
                                }
                                if (whole_answer_correct) {
                                    choice.wrong = false
                                    choice.correct = true
                                }
                            } else {
                                choice.wrong = true
                                if (whole_answer_correct) {
                                    choice.wrong = false
                                    choice.correct = true
                                }
                                if (data.my_answer != undefined) {
                                    data.my_answer[key] = 'Not Answered'
                                } else {
                                    data.my_answer = []
                                    data.my_answer[key] = 'Not Answered'
                                }
                            }
                            key++
                        })
                    } else if (data.type == 'OWQ') {
                        let key = 0
                        let whole_answer_correct = false
                        if (Number(data.my_score) > 0) {
                            whole_answer_correct = true
                        }
                        _.each(data.answer, function (choice) {
                            let correctAnswer = removeSpecialCharacter(choice.desc)
                            if (data.my_answer != undefined && data.my_answer[key] != undefined) {
                                let studentAnswer = removeSpecialCharacter(data.my_answer[key])
                                if (correctAnswer.toLowerCase().trim() !== studentAnswer.toLowerCase().trim()) {
                                    choice.wrong = true
                                } else {
                                    choice.correct = true
                                }
                                if (whole_answer_correct) {
                                    choice.wrong = false
                                    choice.correct = true
                                }
                            } else {
                                choice.wrong = true
                                if (whole_answer_correct) {
                                    choice.wrong = false
                                    choice.correct = true
                                }
                                if (data.my_answer != undefined) {
                                    data.my_answer[key] = 'Not Answered'
                                } else {
                                    data.my_answer = []
                                    data.my_answer[key] = 'Not Answered'
                                }
                            }
                            key++
                        })
                    } else if (data.type == 'MTF') {
                        data.ans_key = []
                        let key = 0
                        _.each(data.option, function (choice) {
                            let needed = true
                            if (!choice.question.desc) {
                                choice['no_question'] = true
                                needed = false
                            }
                            let correctAnswer = removeSpecialCharacter(choice.answer.desc)
                            if (data.my_answer != undefined && data.my_answer[key] != undefined) {
                                let correct = false
                                let studentAnswer = removeSpecialCharacter(data.my_answer[key].desc)
                                if (correctAnswer !== studentAnswer) {
                                    correct = false
                                } else {
                                    correct = true
                                }
                                data.ans_key.push({
                                    desc: data.my_answer[key].desc,
                                    correct: correct,
                                    optImage: data.my_answer[key].optImage,
                                    needed: needed
                                })
                            }
                            key++
                        })
                    } else if (data.type == 'ASLLISTEN') {
                        _.each(data.questions, function (aslListQues) {
                            if (aslListQues.type == 'mcq') {
                                _.each(aslListQues.choice, function (choice) {
                                    if ($scope.checkingChoiceExists(choice.desc, aslListQues)) {
                                        if (!choice.correct) {
                                            choice.wrong = true
                                        }
                                    }
                                })
                            } else if (aslListQues.type == 'tf') {
                                _.each(aslListQues.choice, function (choice) {
                                    if (aslListQues.my_answer != undefined && choice.tag === aslListQues.my_answer) {
                                        if (!choice.correct) {
                                            choice.wrong = true
                                        } else {
                                            choice.correct = true
                                        }
                                    }
                                })
                            } else if (aslListQues.type == 'fib') {
                                _.each(aslListQues.answer, function (choice, index) {
                                    let correctAnswer = removeSpecialCharacter(choice.desc)
                                    if (aslListQues.my_answer != undefined && aslListQues.my_answer[index] != undefined) {
                                        let studentAnswer = removeSpecialCharacter(aslListQues.my_answer[index])
                                        if (correctAnswer.toLowerCase().trim() !== studentAnswer.toLowerCase().trim()) {
                                            choice.wrong = true
                                        } else {
                                            choice.correct = true
                                        }
                                    } else {
                                        choice.wrong = true
                                        if (aslListQues.my_answer != undefined) {
                                            aslListQues.my_answer[index] = 'Not Answered'
                                        } else {
                                            aslListQues.my_answer = []
                                            aslListQues.my_answer[index] = 'Not Answered'
                                        }
                                    }
                                })
                            } else if (aslListQues.type == 'text') {
                                let correctAnswer = removeSpecialCharacter(aslListQues.answer)
                                if (aslListQues.my_answer != undefined) {
                                    let studentAnswer = removeSpecialCharacter(aslListQues.my_answer)
                                    if (correctAnswer.toLowerCase().trim() !== studentAnswer.toLowerCase().trim()) {
                                        aslListQues.wrong = true
                                    } else {
                                        aslListQues.correct = true
                                    }
                                } else {
                                    aslListQues.wrong = true
                                    aslListQues.my_answer = 'Not Answered'
                                }
                            }
                        })
                    }
                })
            })
        }
        $scope.checkingChoiceExists = function (choice, data) {
            let isChecked = false;
            if (data.my_answer != undefined) {
                return data.my_answer.indexOf(choice) > -1
            } else {
                return isChecked
            }
        }
        $scope.gotoQpPreview = function () {
            $state.go('qpSummary', {
                qpId: qpId
            })
        }
        $scope.setFilePath = function (img) {
            let new_url = img ? CONSTANTS.FILE_UPLOAD_URL + img : undefined
            return new_url
        }

        $scope.beautifyFIB = function (question) {
            return question.toString().replace(/_/g, " _______ ")
        }
        let MQ = MathQuill.getInterface(2);
        $scope.loadLatex = function () {
            let questionElements = document.getElementsByClassName('question_desc')
            _.each(questionElements, function (spanElement) {
                MQ.StaticMath(spanElement);
            })
        }
        $scope.conertToHtml = function (string) {
            // string = "<span style='color: #89a000'>123</span>"
            return $sce.trustAsHtml(string);

        }
    }
}
export default StudentAnswerController



// WEBPACK FOOTER //
// ./src/app/traditionalActivity/controllers/studentAnswerView.js